import { render, staticRenderFns } from "./LogoSizePicker.vue?vue&type=template&id=0a404130"
import script from "./LogoSizePicker.vue?vue&type=script&lang=js"
export * from "./LogoSizePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports